export default __webpack_public_path__ + "static/media/include_1@2x.ac324811.jpg";